import styled from "styled-components";

export const Select = styled.select`
  width: 71px;
  height: ${({ theme }) => theme.size};
  margin-left: 10px;
  border-radius: 5px;
  border: none;
  background-color: ${({ theme }) => theme.COMMON};
  font-family: ${({ theme }) => theme.fonts};
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  padding-left: 10px;
  color: ${({ theme }) => theme.WHITE};
  transition-duration: 0.5s;
  &:focus {
    outline: none;
  }
  &:hover {
    transform: scale(0.9);
    cursor: pointer;
  }
`;

export const Option = styled.option`
  height: ${(props) => props.theme.size};
  background-color: ${({ theme }) => theme.DARKLY};
  &:hover {
    cursor: pointer;
  }
`;
